import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { Button } from 'src/components';
import DeleteInformationModal from 'src/components/DeleteInformation/DeleteInformationModal';
import { useDeleteExamEligibilityCriteriaMutation } from 'src/rtk/features/setup/examEligibilityCriteria/examEligibilityCriteriaApi';
import { useGetOrganizationsQuery } from 'src/rtk/features/setup/organization/setupOrganizationApi';

interface Props {
  examEligibilityCriteria: ExamEligibilityCriteria;
  index: number;
}

const ExamEligibilityCriteriaTableRow = ({
  examEligibilityCriteria,
  index,
}: Props) => {
  const history = useHistory();
  
  const [infoId, setInfoId] = useState('');
  const [modalShow, setModalShow] = useState(false);

  const [deleteExamEligibilityCriteria, { isSuccess, isLoading, isError }] =
    useDeleteExamEligibilityCriteriaMutation();
  const { data } = useGetOrganizationsQuery();

  const deleteHandler = (modalState: boolean, id: string) => {
    setModalShow(modalState);
    setInfoId(id);
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success('Exam Eligibility Criteria deleted successfully');
    }
    if (isError) {
      toast.error('Error deleting Exam Eligibility Criteria');
    }
  }, [isSuccess, isError]);

  return (
    <tr key={examEligibilityCriteria.id}>
      <th scope="row">{index + 1}</th>
      <td>{examEligibilityCriteria.eligibility_criteria}</td>
      <td>{examEligibilityCriteria.status ? 'Active' : 'Inactive'}</td>
      <td>
        <div className="d-flex gap-2 justify-content-center">
          <Button
            size="sm"
            text="Edit"
            color="warning"
            onClick={() =>
              history.push(
                `/setup/xm-eligibility-criteria/update/${examEligibilityCriteria.id}`,
              )
            }
          />

          <Button
            size="sm"
            text="Delete"
            color="danger"
            disabled={isLoading}
            isLoading={isLoading}
            onClick={() => deleteHandler(true, examEligibilityCriteria.id!)}
          />
        </div>
        {modalShow ? (
          <DeleteInformationModal
            isOpen={modalShow}
            toggle={() => setModalShow(!modalShow)}
            id={infoId}
            deleteInfomation={deleteExamEligibilityCriteria}
          />
        ) : null}
      </td>
    </tr>
  );
};

export default ExamEligibilityCriteriaTableRow;
